var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8079 1.80786C5.8373 1.80786 1.80786 5.8373 1.80786 10.8079C1.80786 15.7784 5.8373 19.8079 10.8079 19.8079C15.7784 19.8079 19.8079 15.7784 19.8079 10.8079C19.8079 5.8373 15.7784 1.80786 10.8079 1.80786ZM0.307861 10.8079C0.307861 5.00887 5.00887 0.307861 10.8079 0.307861C16.6069 0.307861 21.3079 5.00887 21.3079 10.8079C21.3079 16.6069 16.6069 21.3079 10.8079 21.3079C5.00887 21.3079 0.307861 16.6069 0.307861 10.8079ZM10.8079 6.30786C11.2221 6.30786 11.5579 6.64365 11.5579 7.05786V14.5579C11.5579 14.9721 11.2221 15.3079 10.8079 15.3079C10.3936 15.3079 10.0579 14.9721 10.0579 14.5579V7.05786C10.0579 6.64365 10.3936 6.30786 10.8079 6.30786Z",
    fill: "#939AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/DeactivateIcon.3e0576a2b2e8d00ba8a4d77e01f32c92.svg";
export { ForwardRef as ReactComponent };